import React, {
  useRef,
  useState,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import "./published_hw.css";
import SubjBoxPropsHW from "./Published_Subj_Box/SubjBoxPropsHW";
import Form from "react-bootstrap/Form";
import PublishAccessBoxPropsHW from "../Published/published_access_box/PublishAccessBoxPropsHW";
import SchedAssePropsBoxHW from "../SChedule/Schedule_Assess_box_HW/SchedAssePropsBoxHW";
import DraftAssessPropsBoxHW from "../Draft/Draft_Assess_Box/DraftAssessPropsBoxHW";
import { Link, useNavigate } from "react-router-dom";
import ReviewAssePropsBoxHW from "../../onreview/OnReview_Homework_Box/ReviewAssePropsBoxHW";
import CompletAssepropsBox from "../../Completed/complet_Homework_Box/CompletAssepropsBoxHW";
import FilterBox from "./Filter_Box/FilterBox";
import debounce from "lodash.debounce";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Popup } from "semantic-ui-react";
import HomeworkImage from "./../../../../images/Homework_Process_Flow.png";
import ImagePopupBox from "../../../../DCM/components/PopUp/ImagePopup/ImagePopupBox";
import { ChevronLeft, ChevronRight } from "lucide-react";

const PublishedHomework = ({ leftSidebarSize }) => {
  let general_role = localStorage.getItem("general_role");
  let generalRole_JSON = JSON.parse(general_role);

  let classTeacher = localStorage.getItem("role_as_class_teacher");
  let classTeacher_JSON = JSON.parse(classTeacher);

  let cordinator = localStorage.getItem("role_as_co_ordinator");
  let cordinator_JSON = JSON.parse(cordinator);

  const [openImg, setOpenImg] = useState(false);
  const storedHeader = localStorage.getItem("clickedHeader");
  const [activeHeader, setActiveHeader] = useState(
    storedHeader === "" || storedHeader === null ? "Homework" : storedHeader
  );
  const [activeSubHeader, setActiveSubHeader] = useState(
    localStorage.getItem("buttons") || "Published"
  );
  const buttons = localStorage.getItem("buttons");
  localStorage.setItem("buttons", buttons);
  const [filter, setFilter] = useState({
    subjectId: [],
    date: "",
    time: "",
    searchvalue: "",
    standard_id: "",
    section_id: "",
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [HWName, setHWName] = useState("");

  const navigate = useNavigate();

  // useClickOutside(popupRef, () => setIsPopupOpen(false));

  const handlePopupClick = (event) => {
    event.stopPropagation();
    setIsPopupOpen(!isPopupOpen);
  };

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  let sectionArr = [];
  let standardArr = [];
  const dropDownHelper = () => {
    function addUniqueObjectToArraystand(obj) {
      if (
        !standardArr.some(
          (item) => JSON.stringify(item) === JSON.stringify(obj)
        )
      ) {
        standardArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
    classTeacher_JSON?.map((obj) =>
      addUniqueObjectToArraystand(obj.standard_id)
    );
    cordinator_JSON?.map((obj) => addUniqueObjectToArraystand(obj.standard_id));
  };
  dropDownHelper();
  const handleDropDownSec = () => {
    function addUniqueObjectToArraysect(obj) {
      if (
        !sectionArr.some((item) => JSON.stringify(item) === JSON.stringify(obj))
      ) {
        sectionArr.push(obj);
      }
    }
    generalRole_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    classTeacher_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
    cordinator_JSON?.map((obj) => {
      if (obj?.standard_id?.id === filter?.standard_id) {
        addUniqueObjectToArraysect(obj.section_id);
      }
    });
  };
  handleDropDownSec();
  const setSerchValueToFilter = useCallback(
    debounce((value) => {
      setFilter((prevFilter) => ({
        ...prevFilter,
        searchvalue: value,
      }));
    }, 500), // 500ms debounce delay
    []
  );
  const handleSearch = (e) => {
    setSerchValueToFilter(e.target.value);
  };

  const saved = JSON.parse(localStorage.getItem("temp_Questions_HOMEWORK"));

  const handleCreate = () => {
    if (saved) {
      setHWName(saved?.HomeWorkDetails?.name);
      setOpen(true);
    } else {
      navigate("/CreateHomework");
    }
  };

  console.log(HWName, "HWName");

  const handleContinueSaved = () => {
    setOpen(false);
    navigate("/CreateHomework");
  };

  const handleCreateNew = () => {
    localStorage.removeItem("temp_Questions_HOMEWORK");
    localStorage.removeItem("currentStepHW");
    setOpen(false);
    navigate("/CreateHomework");
  };

  return (
    <div className=" h-100">
      <span className="hw_main_page_heading">Subject-wise Homework</span>
      <div className={` ${leftSidebarSize === 70 ? "expand" : "collapasess"}`}>
        <SubjBoxPropsHW filter={filter} />
      </div>

      <div className="mt-3 me-3 main_button_box w-100 ">
        <div className="col-md- m-0 p-0 d-flex align-items-center justify-content-between main_button_box1">
          <button
            className={` poppins-semibold ${
              activeHeader === "Homework"
                ? "active main_three_button_active orange-text poppins-semibold "
                : "main_three_button "
            }`}
            onClick={(e) => {
              setActiveHeader("Homework");
              localStorage.setItem("clickedHeader", "Homework");
              setActiveSubHeader("Published");
            }}
          >
            Pending
          </button>
          <button
            className={` poppins-semibold ${
              activeHeader === "review"
                ? "active main_three_button_active  orange-text "
                : "main_three_button "
            }`}
            onClick={(e) => {
              setActiveHeader("review");
              setActiveSubHeader("");
              localStorage.setItem("clickedHeader", "review");
            }}
          >
            On Review
          </button>
          <button
            className={` poppins-semibold ${
              activeHeader === "Completed"
                ? "active main_three_button_active  orange-text "
                : "main_three_button "
            }`}
            onClick={(e) => {
              setActiveHeader("Completed");
              setActiveSubHeader("");
              localStorage.setItem("clickedHeader", "Completed");
            }}
          >
            Completed
          </button>
        </div>
        <div className="col-xl-6 col-lg-5 col-md-7 p-0 d-flex align-items-center justify-content-between tablet-layout">
          <div className="col-12 col-md-6 p-0  tab-margin">
            <input
              className="form-control mr-sm-2 m-0 name_search_box "
              type="search"
              placeholder="Search by HW name"
              aria-label="Search"
              maxLength={30}
              onChange={handleSearch}
            />
            <img
              className="name_search_icon"
              src="/images/search icon.svg"
              alt=""
            />
          </div>
          <Popup
            on="click"
            className="popup_filter_box"
            style={{ zIndex: "999" }}
            open={isPopupOpen}
            onOpen={togglePopup}
            onClose={togglePopup}
            trigger={
              <div
                className="col-md-2 col-12 gap-2 filter_button tab-margin"
                onClick={handlePopupClick}
              >
                <img
                  src="/images/filter_icon.svg"
                  alt=""
                  onClick={handlePopupClick}
                />
                <span>Filter</span>
              </div>
            }
            content={
              <div ref={popupRef}>
                <FilterBox
                  setFilter={setFilter}
                  filter={filter}
                  setIsPopupOpen={setIsPopupOpen}
                  togglePopup={togglePopup}
                />
              </div>
            }
            position="bottom center"
          />

          <div
            className=" col-md-3 col-12 gap-2  add_button tab-margin"
            onClick={() => {
              localStorage.setItem("ActiveBtn", "");
              handleCreate();
            }}
          >
            <img src="/images/add icon.svg" alt="" />
            <span>Add Homework</span>
          </div>
        </div>
      </div>

      <div
        className="w-100 me-3 d-flex align-items-center justify-content-between"
        style={{ position: "relative" }}
      >
        <div className="col-lg-3 col-md-4 col-12 mt-3 p-0 m-0 d-flex align-items-center ">
          {activeHeader === "Homework" && (
            <>
              <button
                className={`poppins-semibold ${
                  // buttons === "Published"
                  activeSubHeader === "Published"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  setActiveSubHeader("Published");
                  localStorage.setItem("buttons", "Published");
                }}
              >
                Published
              </button>
              <button
                className={`poppins-semibold ${
                  // buttons === "Draft"
                  activeSubHeader === "Draft"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  setActiveSubHeader("Draft");
                  localStorage.setItem("buttons", "Draft");
                }}
              >
                Draft
              </button>

              {/* <button
                className={` ${
                  // buttons === "Scheduled"
                  activeSubHeader === "Scheduled"
                    ? "active sub_main_three_button_active mx-2"
                    : "sub_main_three_button mx-2"
                }`}
                onClick={(e) => {
                  setActiveSubHeader("Scheduled");
                  localStorage.setItem("buttons","Scheduled");
                }}
              >
                Scheduled
              </button> */}
            </>
          )}
        </div>

        <Alert
          icon={<InfoOutlinedIcon fontSize="small" />}
          severity="info"
          onClick={() => setOpenImg(true)}
          sx={{
            fontSize: "0.8rem",
            cursor: "pointer",
            width: "fit-content",
            padding: "4px 8px",
            "&:hover": {
              backgroundColor: "#e3f2fd", // hover effect
            },
          }}
        >
          Click to Know Details
        </Alert>

        <div className="m-0 mt-1 p-0 col-6 gap-2 col-md-4 mt-3 d-flex align-items-center">
          {/* Class Select */}
          <FormControl size="small" fullWidth sx={{ minWidth: 150 }}>
            <InputLabel>Select Class</InputLabel>
            <Select
              label="Select Class"
              value={filter.standard_id}
              onChange={(e) =>
                setFilter({
                  ...filter,
                  standard_id: e.target.value,
                  section_id: "",
                })
              }
            >
              <MenuItem value="">Select All</MenuItem>
              {standardArr?.length > 0 &&
                [...standardArr]
                  .sort((a, b) => {
                    const aNum = Number(a.name);
                    const bNum = Number(b.name);

                    const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                    if (bothNumeric) {
                      return aNum - bNum; // numeric sort
                    }

                    return a.name.localeCompare(b.name); // alphabetical sort
                  })
                  .map((standard, index) => (
                    <MenuItem
                      key={index}
                      value={standard?.id}
                      name={standard?.name}
                    >
                      {standard?.name}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>

          {/* Section Select */}
          <FormControl size="small" fullWidth sx={{ minWidth: 150, ml: 2 }}>
            <InputLabel>Select Section</InputLabel>
            <Select
              label="Select Section"
              value={filter.section_id}
              onChange={(e) =>
                setFilter({
                  ...filter,
                  section_id: e.target.value,
                })
              }
              disabled={!filter.standard_id} // Class select hone se pehle disable
            >
              <MenuItem value="">Select All</MenuItem>
              {sectionArr &&
                sectionArr.length > 0 &&
                sectionArr
                  .slice()
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((obj) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
        </div>
      </div>
      {/* ////below css comes in published_hw.css////// */}
      <div
        className="mt-3 me-3 button_box_conatainer orange-scrollBar w-100"
        style={{
          maxHeight: "280px",
          width: "100%",
          overflowY: "scroll",
          paddingTop: "1em",
          paddingBottom: "1em",
        }}
      >
        {activeHeader === "review" && <ReviewAssePropsBoxHW filter={filter} />}
        {activeHeader === "Completed" && (
          <CompletAssepropsBox filter={filter} />
        )}
        {activeHeader === "Homework" && activeSubHeader === "Published" && (
          <PublishAccessBoxPropsHW filter={filter} />
        )}
        {/* </div> */}
        {activeHeader === "Homework" && activeSubHeader === "Draft" && (
          <DraftAssessPropsBoxHW filter={filter} />
        )}
        {activeSubHeader === "Scheduled" && (
          <SchedAssePropsBoxHW filter={filter} />
        )}
        {openImg && (
          <ImagePopupBox setOpenImg={setOpenImg} imgSrc={HomeworkImage} />
        )}
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        container={document.body} // ✅ force render inside body
        sx={{ zIndex: 2000 }} // ✅ 5 level higher
      >
        <DialogTitle>Unsaved Changes Found</DialogTitle>
        <DialogContent>
          <Typography>
            You already have an unsaved assessment –{" "}
            <Typography component="span" fontWeight="bold" color="primary">
              {HWName}
            </Typography>
            . Do you want to continue with it or start a new one?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            color="error"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleContinueSaved}
            color="primary"
            variant="outlined"
          >
            Continue Saved
          </Button>
          <Button onClick={handleCreateNew} color="primary" variant="contained">
            Create New
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PublishedHomework;
